import i18n from '@/utils/i18n'

export default {
  // Backend extra_code for a 403 caused by S3 AccessDenied (e.g. blocked by the bucket policy)
  S3_ACCESS_DENIED_EXTRA_CODE: 1,
  ENCRYPTION: [
    'aes128', 'aes192', 'aes256', '3des'
  ],
  HASH: [
    'sha1', 'sha256', 'sha384', 'sha512', 'md5'
  ],
  DIFFIE_HELLMAN: [
    'modp1024 (2)', 'modp1536 (5)', 'modp2048 (14)', ' modp3072 (15)', 'modp4096 (16)', 'modp6144 (17)', 'modp8192 (18)'
  ],
  NETWORK_ITEMS: [
    {
      name: 'Networks',
      get label() { return i18n.t('constants.networkItems.network') },
      path: '/networks',
      icon: 'network',
    },
    {
      name: 'Routers',
      get label() { return i18n.t('constants.networkItems.router') },
      path: '/routers',
      icon: 'router',
    },
    {
      name: 'Security Group',
      get label() { return i18n.t('constants.networkItems.securityGroup') },
      path: '/security-group',
      icon: 'security-group',
    },
    {
      name: 'Floating IP',
      get label() { return i18n.t('constants.networkItems.floatingIp') },
      path: '/floating-ip',
      icon: 'ip',
    },
  ],
  PROTOCOL: [
    {
      name: 'All TCP',
      value: 'tcp',
    },
    {
      name: 'All UDP',
      value: 'udp',
    },
    {
      name: 'Custom UDP',
      value: 'udp',
    },
    {
      name: 'Custom TCP',
      value: 'tcp',
    },
    {
      name: 'SSH',
      value: 'tcp',
      port: 22,
    },
    {
      name: 'HTTP',
      value: 'tcp',
      port: 80,
    },
    {
      name: 'HTTPS',
      value: 'tcp',
      port: 443,
    },
    {
      name: 'MySQL',
      value: 'tcp',
      port: 3306,
    },
    {
      name: 'RDP',
      value: 'tcp',
      port: 3389,
    },
    {
      name: 'IMAP',
      value: 'tcp',
      port: 143,
    },
    {
      name: 'POP3',
      value: 'tcp',
      port: 110,
    },
    {
      name: 'DNS',
      value: 'tcp',
      port: 53,
    },
    {
      name: "ICMP",
      value: 'icmp',
    },
  ],
  SHOW_DIRECTION: ['All TCP', 'All UDP', 'Custom TCP', 'Custom UDP', 'ICMP'],
  SERVER_STATUS: {
    ACTIVE: 'success',
    SHUTOFF: 'gray',
    ERROR: 'danger',
  },
  ORDER_ACTION: {
    resize_load_balancer: 'load-balancer',
    create_load_balancer: 'load-balancer',
    create_server: 'dashboard',
    create_volume: 'volume',
    create_snapshot: 'snapshot',
    billing: 'billing',
    resize_server: 'server',
    scale_temporary_server: 'server',
    resize_volume: 'volume',
    switch_volume_type: 'volume',
    create_wan_ip: 'floating-ip',
    create_router: 'routers',
    update_router: 'routers',
    assign_public_ips: 'networks',
    create_bare_metal_server: 'bare-metal-server',
    create_vpn_gateway: 'vpn',
    create_s3_bucket: 'simple-storage',
    resize_s3_bucket: 'simple-storage',
    switch_volume_iops: 'volume',
    renew_subscription: 'renew',
    upgrade_billing_to_paid_account: 'billing',
  },
  RESIZE_ORDER_ACTION: [
    'resize_load_balancer',
    'resize_server',
    'scale_temporary_server',
    'resize_volume',
    'switch_volume_type',
    'switch_volume_iops',
    'resize_s3_bucket',
  ],
  INVOICE_STATUSES: [
    {
      value: 'open',
      get label() { return i18n.t('constants.invoiceStatus.open') },
      type: ''
    },
    {
      value: 'paid',
      get label() { return i18n.t('constants.invoiceStatus.paid') },
      type: 'success'
    },
    {
      value: 'write-off',
      get label() { return i18n.t('constants.invoiceStatus.writeOff') },
      type: 'warning'
    },
    {
      value: 'draft',
      get label() { return i18n.t('constants.invoiceStatus.draft') },
      type: 'info'
    },
    {
      value: 'error',
      get label() { return i18n.t('constants.invoiceStatus.error') },
      type: 'danger'
    }
  ],
  PAYMENT_METHODS: [
    {
      value: "baokim",
      label: "Bảo Kim",
    },
    {
      value: 'bank',
      get label() { return i18n.t('constants.paymentMethod.bank') },
      type: 'success'
    },
    {
      value: 'coupon',
      get label() { return i18n.t('constants.paymentMethod.coupon') },
      type: 'success'
    },
  ],
  PAYMENT_METHODS_RECEIPTS: [
    {
      value: 'momo',
      label: 'Momo',
      type: 'danger'
    },
    {
      value: 'bank',
      get label() { return i18n.t('constants.paymentMethod.bank') },
      type: 'success'
    },
    {
      value: 'coupon',
      get label() { return i18n.t('constants.paymentMethod.coupon') },
      type: 'success'
    },
    {
      value: 'onepay',
      label: 'Onepay',
      type: 'success'
    },
    {
      value: 'pay2s',
      label: 'Pay2s',
      type: 'success'
    },
    {
      value: 'refund',
      get label() { return i18n.t('constants.paymentMethod.refund') },
      type: 'success'
    },
    {
      value: 'manual',
      get label() { return i18n.t('constants.paymentMethod.manual') },
      type: 'success'
    }
  ],
  PAYMENT_METHODS_BRANDS: [
    // {
    //   value: 'vnpay',
    //   label: 'Vnpay',
    //   disabled: false,
    //   icon: '/payment-gates/vnpay.svg',
    // },
    {
      value: 'baokim',
      label: 'Bảo Kim',
      disabled: false,
      icon: '/payment-gates/baokim.png',
    },
    {
      value: 'banking',
      get label() { return i18n.t('constants.paymentMethod.banking') },
      disabled: true,
      icon: '/payment-gates/banking.svg',
    },
  ],
  SERVER_STATUS_TAG: [
    {
      value: 'ACTIVE',
      type: 'success'
    },
    {
      value: 'SHUTOFF',
      type: 'info'
    },
    {
      value: 'ERROR',
      type: 'danger'
    }
  ],
  LOAD_BALANCER_TAG: [
    {
      value: 'ONLINE',
      type: 'success'
    },
    {
      value: 'success',
      type: 'danger'
    },
    {
      value: 'OFFLINE',
      type: 'danger'
    },
  ],
  VOLUME_TAG: [
    {
      value: 'available',
      type: 'success'
    },
    {
      value: 'in-use',
      type: 'primary'
    },
    {
      value: 'error',
      type: 'danger'
    }
  ],
  PROGRESSING_STATUS: [
    'BUILD',
    'DELETE',
    'RESIZE_SERVER',
    'REBUILD_SERVER',
    'CHANGE_SERVER_TYPE',
  ],
  ROUTER_STATUS: {
    ACTIVE: {
      get label() { return i18n.t('server.active') },
      color: 'success',
    },
  },
  SERVER_GROUP_POLICY: [
    {
      value: 'affinity',
      label: 'Affinity',
    },
    {
      value: 'anti-affinity',
      label: 'Anti Affinity',
    },
    {
      value: 'soft-anti-affinity',
      label: 'Soft Anti Affinity',
    },
    {
      value: 'soft-affinity',
      label: 'Soft Affinity',
    }
  ],
  ERROR_LOGIN_MESSAGE: {
    0: '',
    1: '',
    2: '',
    get 3() { return i18n.t('auth.notActive') },
    get 4() { return i18n.t('auth.locked') },
    get 5() { return i18n.t('auth.badPassword') },
  },
  BILLING_PLAN: [
    'payg',
    'subscription_1_months',
    'subscription_3_months',
    'subscription_6_months',
    'subscription_12_months'
  ],
  ROLE_LIST: [
    'admin', 'billing', 'member',
  ],
  IAM_STATUS: {
    active: {
      color: 'success',
      get label() { return i18n.t('iam.active') },
    },
    blocked: {
      color: 'danger',
      get label() { return i18n.t('iam.blocked') },
    },
    invited: {
      color: 'gray',
      get label() { return i18n.t('iam.invited') },
    },
  },
  SUBSCRIPTION_TYPE: {
    get subscription_1_months() { return i18n.t('constants.subscriptionType.m1') },
    get subscription_3_months() { return i18n.t('constants.subscriptionType.m3') },
    get subscription_6_months() { return i18n.t('constants.subscriptionType.m6') },
    get subscription_12_months() { return i18n.t('constants.subscriptionType.m12') },
    get payg() { return i18n.t('constants.subscriptionType.payg') },
    get subscription() { return i18n.t('constants.subscriptionType.subscription') },
    get server() { return i18n.t('common.server') },
    get volume() { return i18n.t('constants.subscriptionType.volume') },
    get snapshot() { return i18n.t('constants.subscriptionType.snapshot') },
    get 'renew_sub:subscription_1_months'() { return i18n.t('constants.subscriptionType.renewM1') },
    get 'renew_sub:subscription_3_months'() { return i18n.t('constants.subscriptionType.renewM3') },
    get 'renew_sub:subscription_6_months'() { return i18n.t('constants.subscriptionType.renewM6') },
    get 'renew_sub:subscription_12_months'() { return i18n.t('constants.subscriptionType.renewM12') },
    get 'renew:auto'() { return i18n.t('constants.subscriptionType.autoRenew') },
    get 'suspense_state:stop'() { return i18n.t('constants.subscriptionType.stopped') },
    get 'suspend_state:suspend'() { return i18n.t('constants.subscriptionType.suspended') },
    get 'suspend_type:manual'() { return i18n.t('constants.subscriptionType.manualSuspend') },
    get 'load_balancer'() { return i18n.t('constants.subscriptionType.loadBalancer') },
    get 'vpn_gateway'() { return i18n.t('constants.subscriptionType.vpnGateway') },
    get 's3_storage'() { return i18n.t('constants.subscriptionType.s3Storage') },
    get 'wan_ip'() { return i18n.t('constants.subscriptionType.wanIp') },
    get 'floating_ip'() { return i18n.t('constants.subscriptionType.floatingIp') },
    get 'router_ip'() { return i18n.t('constants.subscriptionType.routerIp') },
    get 'trial'() { return i18n.t('constants.subscriptionType.trial') },
    get 'auto_renew:no'() { return i18n.t('constants.subscriptionType.noAutoRenew') },
  },

  PROGRESS_PERCENT_MAPPING: {
    reinstall_os: [
      { min: 0, max: 10, value: "start" },
      { min: 10, max: 20, value: "prepare" },
      { min: 20, max: 50, value: "reinstall" },
      { min: 50, max: 90, value: "update" },
      { min: 90, max: 99, value: "update" },
    ],
    delete_load_balancer: [
      { min: 0, max: 15, value: "start" },
      { min: 25, max: 55, value: "delete" },
    ],
    resize_load_balancer: [
      { min: 0, max: 5, value: "start" },
      { min: 5, max: 25, value: "delete" },
      { min: 25, max: 45, value: "resize" },
      { min: 45, max: 55, value: "waiting" },
      { min: 55, max: 65, value: "create" },
      { min: 65, max: 85, value: "security" },
    ],
    create_load_balancer: [
      { min: 0, max: 5, value: "prepare" },
      { min: 5, max: 45, value: "start" },
      { min: 45, max: 55, value: "waiting" },
      { min: 55, max: 65, value: "create" },
      { min: 65, max: 85, value: "security" },
      { min: 85, max: 99, value: "check" },
    ],
    create_vpn_gateway: [
      { min: 0, max: 5, value: "start" },
      { min: 15, max: 25, value: "init_gateway" },
      { min: 25, max: 35, value: "prepare_network" },
      { min: 35, max: 55, value: "create_gateway" },
      { min: 55, max: 75, value: "create_interface" },
      { min: 75, max: 99, value: "check" },
    ],
    delete_vpn_gateway: [
      { min: 0, max: 15, value: "start" },
      { min: 15, max: 55, value: "delete" },
    ],
    create_server: [
      { min: 0, max: 2, value: "start" },
      { min: 2, max: 10, value: "start" },
      { min: 10, max: 30, value: "interface" },
      { min: 30, max: 50, value: "volume" },
      { min: 50, max: 99, value: "check" },
    ],
    delete_server: [
      { min: 0, max: 2, value: "prepare" },
      { min: 2, max: 35, value: "get" },
      { min: 35, max: 55, value: "resource" },
      { min: 55, max: 75, value: "delete" },
      { min: 75, max: 95, value: "email" },
    ],
    resize_server: [
      { min: 0, max: 40, value: "resize" },
    ],
    rollback_server: [
      { min: 0, max: 2, value: "start" },
      { min: 2, max: 15, value: "prepare" },
      { min: 15, max: 25, value: "get" },
      { min: 25, max: 35, value: "rollback" },
      { min: 35, max: 55, value: "rollback" },
      { min: 55, max: 80, value: "delete" },
    ],
    create_volume: [
      { min: 0, max: 40, value: "create" },
    ],
    resize_volume: [
      { min: 0, max: 40, value: "resize" },
    ],
    create_server_snapshot: [
      { min: 0, max: 99, value: "create" },
    ],
    factory_reset_server: [
      { min: 0, max: 5, value: "start" },
      { min: 5, max: 15, value: "start" },
      { min: 15, max: 35, value: "prepare" },
      { min: 35, max: 75, value: "factory_reset" },
    ],
    create_bare_metal_server: [
      { min: 0, max: 2, value: "start" },
      { min: 2, max: 10, value: "start" },
      { min: 10, max: 25, value: "remove_vif" },
      { min: 25, max: 35, value: "adding_vif" },
      { min: 35, max: 55, value: "create" },
      { min: 55, max: 80, value: "check" },
    ],
    delete_bare_metal_server: [
      { min: 0, max: 2, value: "prepare" },
      { min: 2, max: 35, value: "get" },
      { min: 35, max: 75, value: "delete" },
    ],
  },

  PROGRESS_COLORS: {
    create_server: null,
    resize_server: null,
    rollback_server: 'warning',
    create_volume: null,
    resize_volume: null,
    create_server_snapshot: null,
    factory_reset_server: 'warning',
    reinstall_os: 'warning',
    delete_server: 'warning',
    create_bare_metal_server: null,
    create_vpn_gateway: null,
    delete_vpn_gateway: 'warning',
    delete_load_balancer: 'warning',
  },

  ALGORITHMS: [
    {
      label: "ROUND ROBIN",
      value: "ROUND_ROBIN"
    },
    {
      label: "SOURCE IP",
      value: "SOURCE_IP"
    },
    {
      label: "SOURCE IP PORT",
      value: "SOURCE_IP_PORT"
    },
    {
      label: "LEAST CONNECTIONS",
      value: "LEAST_CONNECTIONS"
    }
  ],

  STICKY_SESSIONS: [
    {
      get label() { return i18n.t('constants.stickySession.none') },
      value: null
    },
    {
      label: "HTTP COOKIE",
      value: "HTTP_COOKIE"
    },
    {
      label: "APP COOKIE",
      value: "APP_COOKIE"
    },
    {
      label: "SOURCE IP",
      value: "SOURCE_IP"
    }
  ],
  LISTENER_METHODS: [
    {
      label: 'HTTP',
      value: 'HTTP'
    },
    {
      label: 'HTTPS',
      value: 'HTTPS'
    },
    {
      label: 'TERMINATED HTTPS',
      value: 'TERMINATED_HTTPS'
    },
    {
      label: 'TCP',
      value: 'TCP'
    },
    {
      label: 'UDP',
      value: 'UDP'
    },
  ],
  ACCESS_CONTROL_LIST: [
    {
      value: 'private',
      get label() { return i18n.t('constants.accessControl.private') },
      description: 'nova',
    },
    {
      value: 'public',
      get label() { return i18n.t('constants.accessControl.public') },
      description: 'nova',
    },
  ],
  INVALID_S3_BUCKET_NAME_CHARACTERS: ['..', '---', '.-', '-.'],
  CHARACTER_DONT_ALLOW: ['..', '---', '.-', '-.'],
  CHARACTER_SPECIAL: ['.', '-'],
  HEALTH_CHECK: ['HTTP', 'HTTPS', 'TCP', 'UDP-CONNECT'],
  VOLUME_TYPES: ['SSD', 'NVME'],
  VPN_STATUS: {
    "up": {
      "type": "success",
      get label() { return i18n.t('constants.vpnStatus.up') },
    },
    "down": {
      "type": "danger",
      get label() { return i18n.t('constants.vpnStatus.down') },
    }
  },
  PRODUCT_IOPS: 'volume_iops',
  MAPPING_PRODUCT_NAME: {
    get "volume_iops"() { return i18n.t('constants.productName.volumeIops') },
    get "fip_qos_policy"() { return i18n.t('constants.productName.fipQosPolicy') },
    get "temp_scale_premium_surcharge"() { return i18n.t('constants.productName.tempScaleSurcharge') },
  },
  MAPPING_OS_TYPES: {
    get "image"() { return i18n.t('constants.osType.image') },
    get "volume"() { return i18n.t('constants.subscriptionType.volume') },
    get "snapshot"() { return i18n.t('constants.osType.serverSnapshot') },
    get "volume_snapshot"() { return i18n.t('constants.osType.volumeSnapshot') },
  },
  MAPPING_USAGE_S3: {
    get "category"() { return i18n.t('common.action') },
    get "bytes_sent"() { return i18n.t('constants.usageS3.bytesSent') },
    get "bytes_received"() { return i18n.t('constants.usageS3.bytesReceived') },
  },
  MAPPING_USAGE_CATEGORY: {
    get create_bucket() { return i18n.t('constants.usageCategory.createBucket') },
    get delete_bucket() { return i18n.t('constants.usageCategory.deleteBucket') },
    get put_obj() { return i18n.t('constants.usageCategory.putObj') },
    get get_obj() { return i18n.t('constants.usageCategory.getObj') },
    get delete_obj() { return i18n.t('constants.usageCategory.deleteObj') },
    get list_obj() { return i18n.t('constants.usageCategory.listObj') },
    get stat_obj() { return i18n.t('constants.usageCategory.statObj') },
  },
  SUB_USER_S3: {
    read: {
      get label() { return i18n.t('constants.subUserS3.read') },
      isShow: true,
    },
    write: {
      get label() { return i18n.t('constants.subUserS3.write') },
      isShow: true,
    },
    "read-write": {
      get label() { return i18n.t('constants.subUserS3.readWrite') },
      isShow: true,
    },
    "full-control": {
      get label() { return i18n.t('constants.subUserS3.fullControl') },
      isShow: true,
    },
    readwrite: {
      get label() { return i18n.t('constants.subUserS3.readWrite') },
      isShow: false,
    },
    full: {
      get label() { return i18n.t('constants.subUserS3.fullControl') },
      isShow: false,
    }
  },
  RESOURCE_TYPES_LABELS: {
    get 'account'() { return i18n.t('constants.resourceType.account') },
    get 'activity_log'() { return i18n.t('constants.resourceType.activity_log') },
    get 'alert'() { return i18n.t('constants.resourceType.alert') },
    get 'availability_zone'() { return i18n.t('constants.resourceType.availability_zone') },
    get 'balance'() { return i18n.t('constants.resourceType.balance') },
    get 'bare_metal'() { return i18n.t('constants.resourceType.bare_metal') },
    get 'category'() { return i18n.t('constants.resourceType.category') },
    get 'coupon'() { return i18n.t('constants.resourceType.coupon') },
    get 'customer_relation'() { return i18n.t('constants.resourceType.customer_relation') },
    get 'discount'() { return i18n.t('constants.resourceType.discount') },
    get 'email'() { return i18n.t('constants.resourceType.email') },
    get 'flavor'() { return i18n.t('constants.resourceType.flavor') },
    get 'floating_ip'() { return i18n.t('constants.resourceType.floating_ip') },
    get 'iam'() { return i18n.t('constants.resourceType.iam') },
    get 'image'() { return i18n.t('constants.resourceType.image') },
    get 'invoice'() { return i18n.t('constants.resourceType.invoice') },
    get 'keypair'() { return i18n.t('constants.resourceType.keypair') },
    get 'load_balancer'() { return i18n.t('constants.resourceType.load_balancer') },
    get 'load_balancer_certificate'() { return i18n.t('constants.resourceType.load_balancer_certificate') },
    get 'load_balancer_flavor'() { return i18n.t('constants.resourceType.load_balancer_flavor') },
    get 'load_balancer_health_monitor'() { return i18n.t('constants.resourceType.load_balancer_health_monitor') },
    get 'load_balancer_listener'() { return i18n.t('constants.resourceType.load_balancer_listener') },
    get 'load_balancer_pool'() { return i18n.t('constants.resourceType.load_balancer_pool') },
    get 'load_balancer_member'() { return i18n.t('constants.resourceType.load_balancer_member') },
    get 'network'() { return i18n.t('constants.resourceType.network') },
    get 'notification'() { return i18n.t('constants.resourceType.notification') },
    get 'notification_template'() { return i18n.t('constants.resourceType.notification_template') },
    get 'order'() { return i18n.t('constants.resourceType.order') },
    get 'otp'() { return i18n.t('constants.resourceType.otp') },
    get 'payment'() { return i18n.t('constants.resourceType.payment') },
    get 'permission'() { return i18n.t('constants.resourceType.permission') },
    get 'port'() { return i18n.t('constants.resourceType.port') },
    get 'preset'() { return i18n.t('constants.resourceType.preset') },
    get 'process'() { return i18n.t('constants.resourceType.process') },
    get 'product'() { return i18n.t('constants.resourceType.product') },
    get 'product_mapping'() { return i18n.t('constants.resourceType.product_mapping') },
    get 'qos_policy'() { return i18n.t('constants.resourceType.qos_policy') },
    get 'quota'() { return i18n.t('constants.resourceType.quota') },
    get 'receiver_email'() { return i18n.t('constants.resourceType.receiver_email') },
    get 'region'() { return i18n.t('constants.resourceType.region') },
    get 'requeue'() { return i18n.t('constants.resourceType.requeue') },
    get 'resource_tag'() { return i18n.t('constants.resourceType.resource_tag') },
    get 'router'() { return i18n.t('constants.resourceType.router') },
    get 'schedule_server_snapshot'() { return i18n.t('constants.resourceType.schedule_server_snapshot') },
    get 'security_group'() { return i18n.t('constants.resourceType.security_group') },
    get 'security_group_rule'() { return i18n.t('constants.resourceType.security_group_rule') },
    get 'server'() { return i18n.t('common.server') },
    get 'server_group'() { return i18n.t('constants.resourceType.server_group') },
    get 'server_snapshot'() { return i18n.t('constants.resourceType.server_snapshot') },
    get 'setting'() { return i18n.t('constants.resourceType.setting') },
    get 'simple_storage'() { return i18n.t('constants.resourceType.simple_storage') },
    get 'simple_storage_account'() { return i18n.t('constants.resourceType.simple_storage_account') },
    get 'simple_storage_bucket'() { return i18n.t('constants.resourceType.simple_storage_bucket') },
    get 'simple_storage_key'() { return i18n.t('constants.resourceType.simple_storage_key') },
    get 'simple_storage_subuser'() { return i18n.t('constants.resourceType.simple_storage_subuser') },
    get 'snapshot'() { return i18n.t('constants.resourceType.snapshot') },
    get 'statistics'() { return i18n.t('constants.resourceType.statistics') },
    get 'status'() { return i18n.t('constants.resourceType.status') },
    get 'subnet'() { return i18n.t('constants.resourceType.subnet') },
    get 'subscription'() { return i18n.t('constants.resourceType.subscription') },
    get 'suspend'() { return i18n.t('constants.resourceType.suspend') },
    get 'system'() { return i18n.t('constants.resourceType.system') },
    get 'task'() { return i18n.t('constants.resourceType.task') },
    get 'ticket'() { return i18n.t('constants.resourceType.ticket') },
    get 'trial'() { return i18n.t('constants.resourceType.trial') },
    get 'vat'() { return i18n.t('constants.resourceType.vat') },
    get 'volume'() { return i18n.t('constants.resourceType.volume') },
    get 'volume_snapshot'() { return i18n.t('constants.resourceType.volume_snapshot') },
    get 'volume_type'() { return i18n.t('constants.resourceType.volume_type') },
    get 'vpn_gateway'() { return i18n.t('constants.resourceType.vpn_gateway') },
    get 'whitelist'() { return i18n.t('constants.resourceType.whitelist') },
  },
  ACTIVITY_LOG_SERVER_ACTIONS: {
    get 'stop'() { return i18n.t('common.off') },
    get 'start'() { return i18n.t('common.on') },
    get 'os-stop'() { return i18n.t('common.off') },
    get 'os-start'() { return i18n.t('common.on') },
    get 'power_on'() { return i18n.t('common.on') },
    get 'power_off'() { return i18n.t('common.off') },
    get 'reboot'() { return i18n.t('constants.serverAction.reboot') },
    get 'restart'() { return i18n.t('constants.serverAction.reboot') },
    get 'hard_reboot'() { return i18n.t('constants.serverAction.hardReboot') },
    get 'rebuild'() { return i18n.t('constants.serverAction.rebuild') },
    get 'suspend'() { return i18n.t('constants.serverAction.suspend') },
    get 'resume'() { return i18n.t('constants.serverAction.resume') },
    get 'reinstall_os'() { return i18n.t('constants.serverAction.reinstallOs') },
    get 'factory_reset'() { return i18n.t('constants.serverAction.factoryReset') },
    get 'resize_flavor'() { return i18n.t('constants.serverAction.resizeFlavor') },
    get 'rollback_server'() { return i18n.t('constants.serverAction.rollbackServer') },
  },
  ACTIVITY_LOG_ORDER_ACTIONS: {
    get 'create_server'() { return i18n.t('constants.orderAction.createServer') },
    get 'delete_server'() { return i18n.t('constants.orderAction.deleteServer') },
    get 'factory_reset_server'() { return i18n.t('constants.orderAction.factoryResetServer') },
    get 'rollback_server'() { return i18n.t('constants.serverAction.rollbackServer') },
    get 'reinstall_os'() { return i18n.t('constants.serverAction.rebuild') },
    get 'resize_server'() { return i18n.t('order.resize_server') },
    get 'scale_temporary_server'() { return i18n.t('order.scale_temporary_server') },
    get 'create_volume'() { return i18n.t('constants.orderAction.createVolume') },
    get 'switch_volume_type'() { return i18n.t('order.switch_volume_type') },
    get 'create_snapshot'() { return i18n.t('constants.orderAction.createSnapshot') },
    get 'delete_snapshot'() { return i18n.t('constants.orderAction.deleteSnapshot') },
    get 'resize_volume'() { return i18n.t('order.resize_volume') },
    get 'switch_volume_iops'() { return i18n.t('order.switch_volume_iops') },
    get 'create_wan_ip'() { return i18n.t('constants.orderAction.createWanIp') },
    get 'resize_port_ip'() { return i18n.t('order.resize_port_ip') },
    get 'assign_public_ips'() { return i18n.t('constants.orderAction.assignPublicIps') },
    get 'change_fip_bandwidth'() { return i18n.t('order.change_fip_bandwidth') },
    get 'create_router'() { return i18n.t('constants.orderAction.createRouter') },
    get 'update_router'() { return i18n.t('constants.orderAction.updateRouter') },
    get 'create_bare_metal_server'() { return i18n.t('constants.orderAction.createBareMetal') },
    get 'delete_bare_metal_server'() { return i18n.t('constants.orderAction.deleteBareMetal') },
    get 'create_vpn_gateway'() { return i18n.t('order.create_vpn_gateway') },
    get 'delete_vpn_gateway'() { return i18n.t('constants.orderAction.deleteVpnGateway') },
    get 'create_load_balancer'() { return i18n.t('order.create_load_balancer') },
    get 'resize_load_balancer'() { return i18n.t('order.resize_load_balancer') },
    get 'delete_load_balancer'() { return i18n.t('constants.orderAction.deleteLoadBalancer') },
    get 'create_s3_bucket'() { return i18n.t('order.create_s3_bucket') },
    get 'resize_s3_bucket'() { return i18n.t('order.resize_s3_bucket') },
    get 'renew_subscription'() { return i18n.t('order.renew_subscription') },
    get 'upgrade_billing_to_paid_account'() { return i18n.t('constants.orderAction.upgradeToPaid') },
    get 'create_server_snapshot'() { return i18n.t('constants.orderAction.createServerSnapshot') },
    get 'delete_server_snapshot'() { return i18n.t('constants.orderAction.deleteServerSnapshot') },
  },
}
